import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='responsible-disclosure-policy'
    backgroundVariant='lightA'
    themeType='lightTheme'
    disableBottomPadding>
    <Row align='center'>
      <Col medium={8}>
        <Typography component='h1' variant='p'>
          Policy Effective as of August 23, 2021
        </Typography>
        <Typography component='h2'>
          Responsible Disclosure Policy
        </Typography>
        <Typography>
          For 160 years, we&#39;ve helped our clients achieve financial security by building lifelong relationships to help them create and carry
          out their financial plans. Spend Your Life Living.
        </Typography>
        <Typography>
          The security and privacy of clients&#39; confidential information are important to Northwestern Mutual. The company takes its responsibility
          to protect this information seriously and uses technical, administrative, and physical controls to safeguard its data.
        </Typography>
        <Typography>
          We want to hear from security researchers (&#34;You&#34; or &#34;Your&#34;) who have information related to suspected security vulnerabilities
          of any Northwestern Mutual services exposed to the internet.
        </Typography>
        <Typography>
          Program now managed by <Link
            id="responsible-disclosure-policy-link"
            variant='primaryDeemphasize'
            linkUrl='https://bugcrowd.com/northwestern-vdp/'
            isOutgoingLink>
            Bugcrowd
          </Link>.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
